export default "__VITE_ASSET__CKOJxnp___"